var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcon24ChevronRight = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EE5F10",
    fillRule: "evenodd",
    d: "M7 11.333c-.17 0-.34-.065-.47-.195-.261-.26-.261-.682 0-.943l2.203-2.203-2.12-2.195c-.256-.266-.248-.688.016-.943.266-.255.688-.248.943.016l2.575 2.667c.252.262.25.677-.008.934l-2.667 2.667c-.13.13-.3.195-.471.195",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcon24ChevronRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_24_chevron-right.762a5635.svg";
export { ForwardRef as ReactComponent };